import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import { Form, Radio, Input, Select, Dropdown } from "semantic-ui-react";
import { toast } from "react-toastify";
import "./AddToCollectionModal.css";
import Modal from "../../../UIComponents/CustomModal/Modal";
import moment from "moment";
import ReactSelect from "react-select";

class AddToCollectionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newColl: false,
            collType: "own",
            collectionName: "",
            tags: "",
            collectionTeams: [],
            collectionId: "",
        };

        this.collTypeOptions = [
            { key: "own", value: "own", text: "OWN" },
            { key: "team", value: "team", text: "TEAM" },
        ];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open === true && this.props.open === false) {
            this.props.getTeamOptions();
            this.setState({
                newColl: false,
                collType: "own",
                collectionName: "",
                tags: "",
                collectionTeams: [],
                collectionId: "",
                selectedColl: "",
            });
        }
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.newColl == true && this.state.newColl == false) {
            this.setState({
                tags: "",
            });
        }
    }

    validateNameLength() {
        return this.state.collectionName.length > 0;
    }
    validateNameLengthLimit() {
        return this.state.collectionName.length > 50;
    }

    validateName() {
        return this.props.collections.map((coll) => coll.name).indexOf(this.state.collectionName) === -1;
    }

    validateNotEmpty() {
        return this.state.collectionId && this.state.collectionId !== undefined;
    }

    validateAddToCollection() {
        if (this.state.newColl && !this.validateNameLength()) {
            toast.warn("Please Enter A Name For The Collection.");
            return false;
        }
        if (this.validateNameLengthLimit()) {
            toast.error("Enter a title for the collection upto maximum 50 characters");
            return false;
        }
        if (this.state.newColl && !this.validateName()) {
            toast.warn("Please Ensure Collection Names Are Unique.");
            return false;
        }
        if (!this.state.newColl && !this.validateNotEmpty()) {
            toast.warn("Please select a collection");
            return false;
        }
        return true;
    }

    addToCollection() {
        if (!this.validateAddToCollection()) return;
        let coll = {
            newColl: this.state.newColl,
            type: this.state.collType,
            name: this.state.collectionName,
            tags: this.state.tags,
            teams: this.state.collectionTeams,
            id: this.state.collectionId,
        };
        this.props.addToCollection(coll);
    }

    handleChangeCollTeam(d) {
        this.setState({
            ...this.state,
            collType: d,
        });
    }

    handleCollNameChange(val) {
        this.setState({
            ...this.state,
            collectionName: val,
            newColl: true,
            collectionId: "",
            selectedColl: "",
            tags: "",
            collType: this.state.newColl ? this.state.collType : "own",
            collectionTeams: this.state.newColl ? this.state.collectionTeams : [],
        });
    }

    handleTagsChange(val) {
        this.setState({
            ...this.state,
            tags: val,
        });
    }

    handleCollectionClick(collId) {
        if (collId === null) {
            this.setState({
                ...this.state,
                newColl: false,
                collectionName: "",
                tags: "",
                collectionId: "",
                selectedColl: "",
            });
        } else {
            let selectedColl = this.props.collections.find((coll) => coll.id === collId.value);
            this.setState({
                ...this.state,
                newColl: false,
                collectionName: "",
                tags: selectedColl.tags || "",
                collectionId: collId.value,
                selectedColl: collId,
            });
        }
    }

    handleCollTeamChange(val) {
        this.setState({
            ...this.state,
            collectionTeams: val,
        });
    }

    getCollectionOptions() {
        return this.props.collections.map((coll) => {
            return { value: coll.id, text: `${coll.name} (${coll.item_count})`, key: coll.id };
        });
    }

    getTeamsIBelongToOptions = (teams) => {
        return teams.map((t) => ({
            value: t.value,
            label: t.text,
        }));
    };

    render() {
        let teamCollections = this.props.collections.filter((coll) => coll.access_type == "2");
        let ownCollections = this.props.collections.filter((coll) => coll.access_type == "0");
        teamCollections = teamCollections.map((coll) => {
            return {
                label: coll.name,
                value: coll.id,
            };
        });
        ownCollections = ownCollections.map((coll) => {
            return {
                label: coll.name,
                value: coll.id,
            };
        });
        const collections = [
            {
                label: "OWN",
                options: ownCollections,
            },
            {
                label: "TEAMS",
                options: teamCollections,
            },
        ];

        return (
            <Modal className={`add-to-collection-modal `} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Add Post To Collection</Modal.Header>
                <Modal.Content className="add-to-collection-modal-content">
                    {/* <Dropdown 
          value={this.state.collectionId} 
          //TODO: check this
          onChange={(e,d) => this.handleCollectionClick(d.value)} 
          placeholder='Collection' 
          fluid search selection 
          className='collection-pick'
          options={this.getCollectionOptions()}
        /> */}
                    <Form.Field>
                        <ReactSelect
                            value={this.state.selectedColl}
                            className="basic-single collection-pick"
                            classNamePrefix="select"
                            placeholder="Search Collections"
                            options={collections}
                            isClearable
                            isSearchable
                            onChange={(e) => this.handleCollectionClick(e)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Input
                            value={this.state.collectionName}
                            onChange={(e, d) => this.handleCollNameChange(d.value)}
                            className={`collection-name ${this.state.newColl ? "" : "new-coll"}`}
                            placeholder="New Collection"
                        />
                        {this.state.newColl && (
                            <Select
                                value={this.state.collType}
                                onChange={(e, d) => this.handleChangeCollTeam(d.value)}
                                className="coll-type"
                                options={this.collTypeOptions}
                            />
                        )}
                    </Form.Field>
                    {this.state.collType === "team" && this.state.newColl && (
                        <Form.Field>
                            <ReactSelect
                                className="basic-single create-teams teams-select"
                                placeholder="Teams"
                                classNamePrefix="select"
                                defaultValue={this.state.collectionTeams}
                                isSearchable
                                name="alerts"
                                isClearable
                                isMulti
                                options={this.getTeamsIBelongToOptions(this.props.teamOptions)}
                                onChange={(e) => this.setState({ collectionTeams: e })}
                            />
                        </Form.Field>
                    )}
                    <Input
                        icon="tags"
                        iconPosition="left"
                        label={{ tag: true, content: "Add Tags" }}
                        labelPosition="right"
                        placeholder="Enter tags"
                        className="tags-input"
                        value={this.state.tags}
                        onChange={(e, d) => this.handleTagsChange(d.value)}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={() => this.addToCollection()}>
                        Save
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default AddToCollectionModal;
